import { EVENT, TYPES } from 'tim-js-sdk';

export enum MessageType {
  MSG_TEXT = TYPES.MSG_TEXT,
  MSG_IMAGE = TYPES.MSG_IMAGE,
  MSG_SOUND = TYPES.MSG_SOUND,
  MSG_AUDIO = TYPES.MSG_AUDIO,
  MSG_FILE = TYPES.MSG_FILE,
  MSG_VIDEO = TYPES.MSG_VIDEO,
  MSG_GEO = TYPES.MSG_GEO,
  MSG_GRP_TIP = TYPES.MSG_GRP_TIP,
  MSG_GRP_SYS_NOTICE = TYPES.MSG_GRP_SYS_NOTICE,
  MSG_CUSTOM = TYPES.MSG_CUSTOM,
  MSG_MERGER = TYPES.MSG_MERGER,
}
export enum MessagePriorityType {
  MSG_PRIORITY_HIGH = TYPES.MSG_PRIORITY_HIGH,
  MSG_PRIORITY_NORMAL = TYPES.MSG_PRIORITY_NORMAL,
  MSG_PRIORITY_LOW = TYPES.MSG_PRIORITY_LOW,
  MSG_PRIORITY_LOWEST = TYPES.MSG_PRIORITY_LOWEST,
}
export enum ConversationType {
  CONV_C2C = TYPES.CONV_C2C,
  CONV_GROUP = TYPES.CONV_GROUP,
  CONV_SYSTEM = TYPES.CONV_SYSTEM,
}
export enum GroupTipOperationType {
  GRP_TIP_MBR_JOIN = TYPES.GRP_TIP_MBR_JOIN,
  GRP_TIP_MBR_QUIT = TYPES.GRP_TIP_MBR_QUIT,
  GRP_TIP_MBR_KICKED_OUT = TYPES.GRP_TIP_MBR_KICKED_OUT,
  GRP_TIP_MBR_SET_ADMIN = TYPES.GRP_TIP_MBR_SET_ADMIN,
  GRP_TIP_MBR_CANCELED_ADMIN = TYPES.GRP_TIP_MBR_CANCELED_ADMIN,
  GRP_TIP_GRP_PROFILE_UPDATED = TYPES.GRP_TIP_GRP_PROFILE_UPDATED,
  GRP_TIP_MBR_PROFILE_UPDATED = TYPES.GRP_TIP_MBR_PROFILE_UPDATED,
}
export enum GroupType {
  GRP_WORK = TYPES.GRP_WORK,
  GRP_PUBLIC = TYPES.GRP_PUBLIC,
  GRP_MEETING = TYPES.GRP_MEETING,
  GRP_AVCHATROOM = TYPES.GRP_AVCHATROOM,
}
export enum GroupMemberRole {
  GRP_MBR_ROLE_OWNER = TYPES.GRP_MBR_ROLE_OWNER,
  GRP_MBR_ROLE_ADMIN = TYPES.GRP_MBR_ROLE_ADMIN,
  GRP_MBR_ROLE_MEMBER = TYPES.GRP_MBR_ROLE_MEMBER,
}

export enum EventEnum {
  SDK_READY = EVENT.SDK_READY,
  SDK_NOT_READY = EVENT.SDK_NOT_READY,
  MESSAGE_RECEIVED = EVENT.MESSAGE_RECEIVED,
  MESSAGE_MODIFIED = EVENT.MESSAGE_MODIFIED,
  MESSAGE_REVOKED = EVENT.MESSAGE_REVOKED,
  MESSAGE_READ_BY_PEER = EVENT.MESSAGE_READ_BY_PEER,
  CONVERSATION_LIST_UPDATED = EVENT.CONVERSATION_LIST_UPDATED,
  GROUP_LIST_UPDATED = EVENT.GROUP_LIST_UPDATED,
  PROFILE_UPDATED = EVENT.PROFILE_UPDATED,
  BLACKLIST_UPDATED = EVENT.BLACKLIST_UPDATED,
  FRIEND_LIST_UPDATED = EVENT.FRIEND_LIST_UPDATED,
  FRIEND_GROUP_LIST_UPDATED = EVENT.FRIEND_GROUP_LIST_UPDATED,
  FRIEND_APPLICATION_LIST_UPDATED = EVENT.FRIEND_APPLICATION_LIST_UPDATED,
  KICKED_OUT = EVENT.KICKED_OUT,
  ERROR = EVENT.ERROR,
  NET_STATE_CHANGE = EVENT.NET_STATE_CHANGE,
  SDK_RELOAD = EVENT.SDK_RELOAD,
}
